<template>
  <a-card class="market-resource">
    <a-tabs :activeKey="activeKey" @change="changeTab">
      <a-tab-pane key="marketing" tab="市场部" v-if="authCheck.marketing && authCheck.marketing.auth"> </a-tab-pane>
      <a-tab-pane key="curriculum" tab="课程部" v-if="authCheck.curriculum && authCheck.curriculum.auth"> </a-tab-pane>
      <a-tab-pane key="productTechnology" tab="产品技术部" v-if="authCheck.productTechnology && authCheck.productTechnology.auth"> </a-tab-pane>
      <a-tab-pane key="gameDep" tab="游戏部" v-if="authCheck.gameDep && authCheck.gameDep.auth"> </a-tab-pane>
    </a-tabs>
    <div class="route-view-container">
      <router-view :key="$route.path"></router-view>
    </div>
  </a-card>
</template>
<script>
import { hasPermission } from '@/utils/authority-utils'
const authCheck = {
  marketing: {
    path: '/content/MarketResource/marketing',
    auth: false,
  },
  curriculum: {
    path: '/content/MarketResource/curriculum',
    auth: false,
  },
  productTechnology: {
    path: '/content/MarketResource/productTechnology',
    auth: false,
  },
  gameDep: {
    path: '/content/MarketResource/gameDep',
    auth: false,
  },
}
export default {
  name: 'MarketResource',
  data() {
    return {
      activeKey: '',
    }
  },
  computed: {
    authCheck() {
      return this.$store.state.content.authMarksTabs || {}
    },
  },
  created() {
    if (this.$route.path == '/content/MarketResource' || !this.$store.state.content.authMarksTabs) {
      this.initAuth()
    } else {
      this.activeKey = this.$route.path.split('/').at(-1)
    }
  },
  methods: {
    initAuth() {
      if (!this.$store.state.content.authMarksTabs) {
        let count = 0
        this.visitByKeys(
          this.$router.options.routes,
          Object.values(authCheck).map((v) => v.path),
          (route) => {
            const activeKey = route.path.split('/').at(-1)
            if (count == 0) {
              if (this.$route.path == '/content/MarketResource') {
                this.changeTab(activeKey)
              } else {
                this.activeKey = this.$route.path.split('/').at(-1)
              }
            }
            authCheck[activeKey].auth = hasPermission(route?.meta?.authority, this.$store.state.account.permissions)
            ++count
            if (count == 4) {
              return true
            }
          }
        )
        this.$store.commit('content/setAuthMarksTabs', authCheck)
      } else {
        Object.values(this.authCheck).some((v) => {
          if (v.auth) {
            const activeKey = v.path.split('/').at(-1)
            this.changeTab(activeKey)
            return true
          }
        })
      }
    },
    changeTab(e) {
      this.activeKey = e
      this.$router.replace('/content/MarketResource/' + e)
    },
    visitByKeys(data = [], keys, visit) {
      const stack = [...data]
      while (stack.length) {
        const item = stack.pop()
        if (keys.includes(item.fullPath)) {
          const stop = visit(item)
          if (stop) {
            return
          }
        }
        const c = item.children || []
        if (c.length) {
          for (let i = c.length - 1; i >= 0; i--) {
            stack.push(c[i])
          }
        }
      }
      return
    },
  },
}
</script>
<style scoped lang="less">
.market-resource {
  background: #fff;
  .route-view-container {
    background: #fff;
  }
}
</style>
